import React from "react";
import Dialog from "@material-ui/core/Dialog";
import { DialogTitle } from "../components/DialogTitle";
import { DialogContent } from "../components/DialogContent";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import { TextInput } from "../components/TextInput";
import { FileInput } from "../components/FileInput";
import { ChipsType } from "../components/ChipsType";

import SelectOrganization from "../containers/SelectOrganization";
import { GlobalAccessCheckbox } from "../components/GlobalAccessCheckbox";

export const EditExternalAppDialog = ({
  app,
  onClose,
  onSave,
  saveAvaliable,
  title,
  onTitleChange,
  packageName,
  onPackageNameChange,
  packageNameNotUnique,
  categories,
  onCategoriesChange,
  sortPriority,
  onSortPriorityChange,
  description,
  onDescriptionChange,
  iconName,
  onIconFileChange,
  organizationKey,
  onOrganizationChange,
  globalAccess,
  onGlobalAccessChange
}) => (
  <Dialog maxWidth="lg" scroll="body" onClose={onClose} open>
    <DialogTitle
      onCancel={onClose}
      onSave={onSave}
      saveAvaliable={saveAvaliable}
    >
      External App: {app.title}
    </DialogTitle>
    <DialogContent>
      <Typography variant="caption">*Required Inputs</Typography>
      <Grid container spacing={3}>
        <Grid item xs={6}>
          <TextInput
            label="Title"
            value={title}
            onChange={onTitleChange}
            required
          />
          <TextInput
            label={packageNameNotUnique ? "Must be unique" : "Package Name"}
            value={packageName}
            onChange={onPackageNameChange}
            required
            error={packageNameNotUnique}
          />
          <br />
          <br />
          <ChipsType
            data={categories}
            title="Categories"
            onChange={onCategoriesChange}
          />
          <TextInput
            label="Sort Priority"
            value={sortPriority}
            onChange={onSortPriorityChange}
            onFocus={event => event.target.select()}            
          />      
        </Grid>
        <Grid item xs={6}>
          {!iconName && <img src={app.iconUrl} style={{ width: 100 }} />}
          <br />
          <FileInput
            id="icon-button-file"
            accept=".png"
            onChange={onIconFileChange}
          >
            New Icon Image
          </FileInput>
          {iconName}
        </Grid>
        <Grid item xs={12}>
          <TextInput
            label="Description"
            value={description}
            onChange={onDescriptionChange}
            multiline
          />
          <br />
          <br />
          <SelectOrganization
            value={organizationKey}
            onChange={onOrganizationChange}
          />
          <br />
          <GlobalAccessCheckbox
            value={globalAccess}
            onChange={onGlobalAccessChange}
          />
        </Grid>
      </Grid>
      <br />
    </DialogContent>
  </Dialog>
);
